import { render, staticRenderFns } from "./NewAuditModal.vue?vue&type=template&id=bc8d1c4c&"
import script from "./NewAuditModal.vue?vue&type=script&lang=ts&"
export * from "./NewAuditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports